import { lazy } from 'react'
import { createBrowserRouter } from 'react-router-dom'

import { GenericErrorPage, NotFoundPage } from '@/common/components'
import ChunkLoadError from '@/common/components/ChunkLoadError/ChunkLoadError'
import UserRequiredContainer from '@/common/components/UserRequiredContainer/UserRequiredContainer'
import { Paths } from '@/common/utils'
import { LEGACY_PROFORMA_PATHNAME, redirectLegacyProforma } from '@/features/documents/redirectLegacyProforma'

// Keep critical routes as direct imports for fast initial load
import Home from './features/home/Home'
import Logout from './features/logout/Logout'
import Order from './features/order/Order'

// Low-risk routes - convert to lazy loading first
const AccountSettings = lazy(() => import('./features/account-settings/AccountSettings'))
const Documents = lazy(() => import('./features/documents/views/Documents'))
const PartLibrary = lazy(() => import('./features/part-library/PartLibrary'))

// Medium-risk routes - convert to lazy loading
const OrderCheckout = lazy(() => import('./features/order-checkout/OrderCheckout'))
const OrderHistory = lazy(() => import('./features/order-history/OrderHistory'))
const OrderReview = lazy(() => import('./features/order-review/OrderReview'))

// High-risk routes - convert to lazy loading
const OrderConfirmation = lazy(() => import('./features/order-confirmation/OrderConfirmation'))
const PaymentSuccess = lazy(() => import('./features/payments/PaymentSuccess'))

export const router = createBrowserRouter([
    {
        path: LEGACY_PROFORMA_PATHNAME,
        loader: redirectLegacyProforma,
    },
    {
        path: '/',
        element: <UserRequiredContainer />,
        ErrorBoundary: GenericErrorPage,
        children: [
            {
                index: true,
                element: <Home />,
            },
            {
                path: Paths.ORDER_PATHNAME,
                element: <Order />,
            },
            {
                path: Paths.ORDER_REVIEW_PATHNAME,
                element: (
                    <ChunkLoadError>
                        <OrderReview />
                    </ChunkLoadError>
                ),
            },
            {
                path: Paths.ORDER_CHECKOUT_PATHNAME,
                element: (
                    <ChunkLoadError>
                        <OrderCheckout />
                    </ChunkLoadError>
                ),
            },
            {
                path: Paths.ORDER_CONFIRMATION_PATHNAME,
                element: (
                    <ChunkLoadError>
                        <OrderConfirmation />
                    </ChunkLoadError>
                ),
            },
            {
                path: Paths.ORDER_PAYMENT_SUCCESS,
                element: (
                    <ChunkLoadError>
                        <PaymentSuccess />
                    </ChunkLoadError>
                ),
            },
            {
                path: Paths.ORDER_HISTORY_PATHNAME,
                element: (
                    <ChunkLoadError>
                        <OrderHistory />
                    </ChunkLoadError>
                ),
            },
            {
                path: Paths.PARTS_LIBRARY_PATHNAME,
                element: (
                    <ChunkLoadError>
                        <PartLibrary />
                    </ChunkLoadError>
                ),
            },
            {
                path: Paths.ACCOUNT_PATHNAME,
                element: (
                    <ChunkLoadError>
                        <AccountSettings />
                    </ChunkLoadError>
                ),
            },
            {
                path: Paths.DOCUMENTS_PATHNAME,
                element: (
                    <ChunkLoadError>
                        <Documents />
                    </ChunkLoadError>
                ),
            },
            {
                path: Paths.LOGOUT_PATHNAME,
                element: <Logout />,
            },
            {
                path: Paths.ERROR_PATHNAME,
                element: <GenericErrorPage />,
            },
            {
                path: Paths.NOT_FOUND,
                element: <NotFoundPage />,
            },
            {
                path: '*',
                element: <NotFoundPage />,
            },
        ],
    },
])
